import React from 'react';
import { Route, Switch } from 'react-router-dom';
import Login from 'views/login';
import Register from 'views/register';
import RegisterStepTwo from 'views/register-step-two';
import HomeModule from 'views/home';
import FamilyStructureModule from 'views/family-structure';
import VehicleModule from 'views/vehicle';
import EducationModule from 'views/education';
import LanguageModule from 'views/language';
import KnowledgeAndSkillsModule from 'views/knowledgeAndSkills';
import ExperienceModule from 'views/experience';
import ReferenceModule from 'views/references';
import JobAppliedInformationModule from 'views/jobAppliedInformation';
import AttachmentsModule from 'views/attachments';
import ChangePassword from 'views/changePassword';
import ChangePasswordStepOne from 'views/changePasswordStepOne';
import ChangePasswordStepTwo from 'views/changePasswordStepTwo';
import TalentosModule from 'views/talentos/TalentosModule';

import PrivateRoute from './PrivateRouteWrapper';
import PublicRoute from './PublicRouterWrapper';


const Router = () => {
    return (
        <Switch>
            <PrivateRoute path="/" exact component={HomeModule} />
            <PrivateRoute path="/familyStructure" component={FamilyStructureModule} />
            <PrivateRoute path="/vehicle" component={VehicleModule} />
            <PrivateRoute path="/education" component={EducationModule} />
            <PrivateRoute path="/language" component={LanguageModule} />
            <PrivateRoute path="/talents" component={TalentosModule} />
            <PrivateRoute path="/knowledgeAndSkillsModule" component={KnowledgeAndSkillsModule} />
            <PrivateRoute path="/experience" component={ExperienceModule} />
            <PrivateRoute path="/reference" component={ReferenceModule} />
            <PrivateRoute path="/jobAppliedInformation" component={JobAppliedInformationModule} />
            <PrivateRoute path="/attachments" component={AttachmentsModule} />
            <PublicRoute path="/SolicitudEmpleo/IniciarSesion" component={Login} />
            <PublicRoute path="/register" exact component={Register} />
            <PublicRoute path="/validateUser" component={RegisterStepTwo} />
            <PublicRoute path="/changePassword" exact component={ChangePassword} />
            <PublicRoute path="/changePasswordStepOne" component={ChangePasswordStepOne} />
            <PublicRoute path="/changePasswordStepTwo" component={ChangePasswordStepTwo} />
        </Switch>
    )
};

export default Router;